import * as React from 'react'
import './index.css'
type LayoutProps = {
    children: React.ReactNode
    custom?: boolean
}

const Card = ({ children, custom }: LayoutProps) => {
    return (
        <>
            <div className={custom ? 'content mg-20 test' : 'content mg-20'}>
                {children}
            </div>
        </>
    )
}
export default Card
